'use strict';

var MarketAnalysisModeDirective = function MarketAnalysisModeDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/market-analysis-mode.html'),
    controller: 'MarketAnalysisModeController',
    scope: {
      changeFilter: '&',
      scenarioName: '=?',
      screenState: '=',
      reoptPreviewData: '='
    },
    link: function link(scope) {
      scope.$on('brush-filter:defaultBrush', scope.onDefaultBrushFilter);
      scope.$broadcast('search-criteria:searchChangeEvent');
      scope.$on('grid:rowSelectionChanged', scope.onRowSelection);
    }
  };
};
MarketAnalysisModeDirective.$inject = [];
module.exports = MarketAnalysisModeDirective;